/**
 * Event types supported by the tracking system.
 * These should align with the backend EventType enum.
 * Generic events (CLICK, PAGE_VIEW, etc.) are added for UI-side tracking logic
 * and will require backend support for ingestion.
 */
export enum EventType {
  CITY_SELECTED = "CITY_SELECTED",
  SEARCH_PERFORMED = "SEARCH_PERFORMED",
  CATEGORY_SELECTED = "CATEGORY_SELECTED",
  PROVIDER_VIEWED = "PROVIDER_VIEWED",
  CATEGORY_RETURNED_KEYWORD_SEARCH = "CATEGORY_RETURNED_KEYWORD_SEARCH",
  PRICING_VIEWED = "PRICING_VIEWED",

  // Temporarily disabled event types. Only RTM-approved reporting events remain active.
  /*
  // Existing Backend Event Types
  USER_LOGIN = "USER_LOGIN",
  USER_LOGOUT = "USER_LOGOUT",
  USER_REGISTER = "USER_REGISTER",
  USER_UPDATE = "USER_UPDATE",
  USER_DELETE = "USER_DELETE",
  PASSWORD_RESET = "PASSWORD_RESET",
  OTP_SENT = "OTP_SENT",
  OTP_VERIFIED = "OTP_VERIFIED",
  SESSION_CREATED = "SESSION_CREATED",
  SESSION_EXPIRED = "SESSION_EXPIRED",
  SERVICE_PROVIDER_CREATED = "SERVICE_PROVIDER_CREATED",
  SERVICE_PROVIDER_UPDATED = "SERVICE_PROVIDER_UPDATED",
  SERVICE_REQUEST_CREATED = "SERVICE_REQUEST_CREATED",
  SERVICE_REQUEST_UPDATED = "SERVICE_REQUEST_UPDATED",
  SERVICE_REQUEST_COMPLETED = "SERVICE_REQUEST_COMPLETED",
  PAYMENT_INITIATED = "PAYMENT_INITIATED",
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED",
  PAYMENT_FAILED = "PAYMENT_FAILED",

  // Generic Web Events (UI-Side)
  CLICK = "CLICK",
  PAGE_VIEW = "PAGE_VIEW",
  API_CALL = "API_CALL",
  FORM_SUBMISSION = "FORM_SUBMISSION",
  CUSTOM_BUSINESS_EVENT = "CUSTOM_BUSINESS_EVENT",
  */
}

/**
 * Action source types for provider interactions.
 * These align with the backend SourceType enum and reporting_source_type collection.
 */
export enum ActionSourceType {
  CALL = "CALL",
  WHATSAPP = "WHATSAPP",
}
